import React, { useEffect } from "react";
import _get from "lodash/get";
import { forceCheck } from "react-lazyload";
import PromoProductsGrid from "@containers/Promo/PromoProductsGrid";
import PromoBanner from "@containers/Promo/PromoBanner";
import Button from "@components/Button";

const findSiblingCategories = (currentCategory, categories, campaign) => {
  const allCategories = [];

  // TODO: deadline and 4:20 in the morning, recursion..

  // Categories lvl 1
  for (const category of categories) {
    if (category.product_ids && !category.subcategories) {
      allCategories.push({
        id: category.id,
        name: category.name,
        url: `/promo/${campaign.slug}/${category.slug}/`,
      });
    }

    if (category.subcategories) {
      // Categories lvl 2
      for (const subcategory of category.subcategories) {
        if (subcategory.product_ids && !subcategory.subcategories) {
          allCategories.push({
            id: subcategory.id,
            name: subcategory.name,
            url: `/promo/${campaign.slug}/${category.slug}/${subcategory.slug}/`,
          });
        }

        if (subcategory.subcategories) {
          // Categories lvl 3
          for (const subSubcategory of subcategory.subcategories) {
            allCategories.push({
              id: subSubcategory.id,
              name: subSubcategory.name,
              url: `/promo/${campaign.slug}/${category.slug}/${subcategory.slug}/${subSubcategory.slug}/`,
            });
          }
        }
      }
    }
  }

  const currentCategoryIndex = allCategories.findIndex(
    (category) => category.id === currentCategory.id
  );

  return {
    previousCategory: allCategories[currentCategoryIndex - 1],
    nextCategory: allCategories[currentCategoryIndex + 1],
  };
};

const PromoProducts = ({
  sort,
  filters,
  categories,
  products: productsMap,
  category,
  campaign,
}) => {
  useEffect(() => {
    forceCheck();
  }, [sort, filters]);

  const { previousCategory, nextCategory } = findSiblingCategories(
    category,
    categories,
    campaign
  );

  return (
    <>
      <PromoProductsGrid
        products={(category.product_ids || [])
          .map((id) => productsMap[id])
          .filter(Boolean)}
        sort={sort}
        filters={filters}
        campaign={campaign}
      />

      <div className="hidden lg:flex justify-between items-center mt-10">
        <div className="sm:w-full sm:max-w-[220px]">
          {previousCategory && (
            <Button
              title="Categoria anterioara"
              display="block"
              variant="third"
              classesProp="group-with-promoDarkTheme:bg-transparent group-with-promoDarkTheme:text-white"
              href={previousCategory.url}
            />
          )}
        </div>

        <div className="flex justify-center w-full">
          {_get(category, "properties.view_all_link", "") && (
            <div className="w-full max-w-[260px]">
              <Button
                title={category.properties.view_all_text || "Vezi toata oferta"}
                display="block"
                variant="primary"
                href={category.properties.view_all_link}
              />
            </div>
          )}
        </div>

        <div className="sm:w-full sm:max-w-[220px]">
          {nextCategory && (
            <Button
              title="Categoria urmatoare"
              display="block"
              variant="third"
              classesProp="group-with-promoDarkTheme:bg-transparent group-with-promoDarkTheme:text-white"
              href={nextCategory.url}
            />
          )}
        </div>
      </div>

      <div className="block lg:hidden mt-10">
        <div className="flex justify-center w-full">
          {nextCategory && (
            <div className="w-full mb-5">
              <Button
                title={`${nextCategory.name} →`}
                display="block"
                variant="third"
                href={nextCategory.url}
                classesProp="group-with-promoDarkTheme:bg-transparent group-with-promoDarkTheme:text-white"
              />
            </div>
          )}
        </div>

        {_get(category, "properties.view_all_link", "") && (
          <div className="flex justify-center w-full">
            <div className="w-full mb-5">
              <Button
                title={category.properties.view_all_text || "Vezi toata oferta"}
                display="block"
                variant="primary"
                href={category.properties.view_all_link}
              />
            </div>
          </div>
        )}

        <div className="flex justify-center w-full">
          {previousCategory && (
            <div className="w-full mb-5">
              <Button
                title={`← ${previousCategory.name}`}
                display="block"
                variant="third"
                href={previousCategory.url}
                classesProp="group-with-promoDarkTheme:bg-transparent group-with-promoDarkTheme:text-white"
              />
            </div>
          )}
        </div>
      </div>

      {_get(category, "properties.banner1") && (
        <div className="mt-16">
          {category.properties.banner_link ? (
            <a href={category.properties.banner_link} title="">
              <PromoBanner
                large={category.properties.banner1}
                medium={category.properties.banner2}
                small={category.properties.banner3}
              />
            </a>
          ) : (
            <PromoBanner
              large={category.properties.banner1}
              medium={category.properties.banner2}
              small={category.properties.banner3}
            />
          )}
        </div>
      )}
    </>
  );
};

export default PromoProducts;
